import type { FetchResponse } from '@sydle/ui-api';
import { portalCustomAPI } from '.';
import type { ImportPackageUI } from '../models/ImportPackageUI';

export interface GetSectionContentInput {
  section: { [key: string]: any };
  application: string;
}

export interface GetSectionContentOutput {
  content?: string;
  packageScripts?: ImportPackageUI[];
}

export function getSectionContent(input: GetSectionContentInput): Promise<FetchResponse<GetSectionContentOutput>> {
  return portalCustomAPI.fetch<GetSectionContentInput, GetSectionContentOutput>('getSectionContent', input);
}
